export default {
  path: '/lvy-let-sign-sensitive-info',
  component: () => import('./LVYLetSignSensitiveInfo'),
  meta: {
    title: '敏感个人信息清单',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}